import React from 'react';
import { Header_2026, Footer_2026, LibroAzul_2026 } from '../container';



const LibroAzul = () => {

    return (
        <>
            <Header_2026 />
            <main _ngcontent-ng-c2339870667="" class="app-shell__page">
                <router-outlet _ngcontent-ng-c2339870667="">
                </router-outlet>
                <LibroAzul_2026 />
            </main>
            <Footer_2026 />

        </>
    );

}

export default LibroAzul;